module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAYCAMAAAD08pwfAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAPFBMVEUAAACvr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr688bl2LAAAAE3RSTlMAbPxF8CfbEr0Glm1GKBOXmBQp8TP4YwAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAABOSURBVBjTbc9JEoAgDERRRIzgAGrf/67ufqwyWb1FKp1OU2LyDFUWKFuhaoPanNqd+YAqJ5R1qNqghvMKFuzm2BNEePAInrT+L/Sp6eVfgSQIrGtSSOQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/right-grey5@2x.png
// module id = 793
// module chunks = 0 1 2 3 4